export const roundDown = (offset, limit) => Math.floor(offset / limit) * limit;
